import styled from '@emotion/styled'
import { Flex } from 'mailup-web-components'
import PropTypes from 'prop-types'

const LineNextToStep = ({ isDisabled, isFirst, isLast }) => {
  return (
    <>
      <Container height='100%' width='100%'>
        <Icon disabled={isDisabled} />
        <Line isFirst={isFirst} isLast={isLast} />
      </Container>
    </>
  )
}

export default LineNextToStep

LineNextToStep.propTypes = {
  isDisabled: PropTypes.bool,
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool
}

const Container = styled(Flex)`
  position: relative;
`
const Icon = styled.span`
  position: absolute;
  top: 16px;
  left: 0;
  z-index: 2;
  content: '';
  width: 26px;
  height: 26px;
  background-color: ${({ disabled }) =>
    disabled ? 'var(--silver)' : 'var(--java)'};
  border-radius: 50%;
  border: 5px solid ${({ disabled }) => (disabled ? '#e5e5e5' : '#8bd3e6')};
`
const Line = styled.span`
  background-color: #e5e5e5;
  position: absolute;
  width: 4px;
  height: ${({ isLast }) => (isLast ? '20px' : 'calc(10px + 100%)')};
  left: 11px;
  z-index: 0;
  top: ${({ isFirst, isLast }) => (isFirst ? '20px' : isLast ? 0 : 'auto')};
`
